export const googleMaps = {
  API_KEY: 'AIzaSyA4YzpgFeX69xtBHdfPshtDmOKfgV8X9HA',
  COORDS: { lat: 50.087441, lng: 20.047753 },
};
